import { AxiosError } from "axios";
import { DateTime } from "luxon";

export const formatDate = (date?: string): string => {
  return date ? DateTime.fromISO(date).toFormat("dd/MM/yyyy") : "";
};

export const getAge = (
  examDate: Date | string | undefined,
  dateOfBirth: Date | string | undefined
) => {
  if (!dateOfBirth || !examDate) return undefined;

  const luxonBirthDate =
    typeof dateOfBirth === "string"
      ? DateTime.fromISO(dateOfBirth)
      : DateTime.fromJSDate(dateOfBirth);

  const luxonExamDate =
    typeof examDate === "string"
      ? DateTime.fromISO(examDate)
      : DateTime.fromJSDate(examDate);

  return Math.floor(luxonExamDate.diff(luxonBirthDate, "years").years);
};

export const isNotFoundError = (error: unknown): boolean =>
  error instanceof AxiosError && error.response?.status === 404;

export const extractApiError = (
  error: Error | null,
  defaultError: string = "Something went wrong, please try again."
): string => {
  if (
    error instanceof AxiosError &&
    error.response?.data?.error &&
    Array.isArray(error.response?.data.error) &&
    "message" in error.response.data.error[0]
  ) {
    return error.response?.data.error[0].message;
  }
  return defaultError;
};
